import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {Checkbox, Col, Row} from "react-bootstrap";
import * as MyActions from "./actions";
import {addAlert} from "../App/actions";
import {showDock} from "../../components/dock/actions";
import CustomerViewMenu from "./CustomerViewMenu";
import CustomerViewTabs from "./CustomerViewTabs";
import MDSpinner from "react-md-spinner";
import './CustomerViewPage.scss'
import {withMediaQuery} from '../../utilities/hooks/useMediaQuery';

const Actions = {...MyActions, addAlert, showDock}

class CustomerViewSettings extends Component {
    state = {
        loading: true,
        saving: false,
        smsOptIn: false
    }

    componentWillMount = () => {
        if (!this.props.params.token) {
            this.props.actions.addAlert({
                message: "Proposal not given. I can't go on!",
            })
            return
        }

        this.props.actions.loadCustomerSettings(this.props.params.token, res => {
            this.setState({
                loading: false,
                smsOptIn: !!res.sms_opt_in
            })
        })
    }

    handleSmsOptInChange = e => {
        const smsOptIn = e.target.checked
        const previousValue = this.state.smsOptIn

        this.setState({smsOptIn, saving: true})

        this.props.actions.updateSmsOptIn(
            this.props.params.token,
            smsOptIn,
            res => {
                this.setState({
                    smsOptIn: !!res.sms_opt_in,
                    saving: false
                })
            },
            () => {
                this.setState({
                    smsOptIn: previousValue,
                    saving: false
                })
            }
        )
    }

    render() {
        const {client, params, isMobile} = this.props
        const {loading, saving, smsOptIn} = this.state
        const clientLogo = client ? client.client_logo_selected : ''

        return (
            <div id="customerView" className={`${isMobile ? "customerView--Mob" : "customerView"}`}>
                <Row className='customerView__header customerView__header--disable-grid'>
                    <Col md={2} xs={12} className='company-logo'><img src={clientLogo}/></Col>
                    <Col md={8} xs={12} className='align-center white-stripe'>
                        <p className='title'>Notification Settings</p>
                        {!loading && <p className='subtitle'>Choose whether you want to receive text messages</p>}
                    </Col>
                </Row>
                {isMobile
                    ? <Col md={12}>
                        <CustomerViewMenu token={params.token}/>
                    </Col>
                    : <Row className="customerView__tabs">
                        <Col md={12}>
                            <CustomerViewTabs token={params.token}/>
                        </Col>
                    </Row>
                }
                <Row className='customerView__content align-center'>
                    <Col md={8} mdOffset={2} xs={12} className='items-container'>
                        {loading
                            ? <MDSpinner className="mt-20"/>
                            : <Row className='item-link item-link--static'>
                                <div className='item-header'>
                                    <div className='item-title'>SMS notifications</div>
                                </div>
                                <div className='item-data'>
                                    <Checkbox checked={smsOptIn}
                                              disabled={saving}
                                              onChange={this.handleSmsOptInChange}>
                                        SMS Allowed
                                    </Checkbox>
                                </div>
                            </Row>}
                    </Col>
                </Row>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        client: state.client.customerInfo
    }
}

const mapDispatchToProps = dispatch => {
    return {actions: bindActionCreators(Actions, dispatch)}
}

const CustomerViewSettingsWithMedia = withMediaQuery(CustomerViewSettings, {
    isMobile: { maxWidth: 991 },
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomerViewSettingsWithMedia);
